import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import omit from "lodash/omit";
import { LocalizationStore } from "../localization/LocalizationStore";
/**
 * Return an object from ISO code to localized names, in localized order.
 *
 * We create a function that wraps this so we can change what is returned by
 * localize in a node environment where locale may change. This is useful
 * for the web-email-server, where we cannot hard-refresh when changing locales.
 */ export var getIsoToCountryNames = function(strictLocalize) {
    var ISO_TO_COUNTRY_NAME_UNSORTED = {
        AFG: strictLocalize({
            id: "lDR7ZS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Afghanistan"
                }
            ]
        }),
        ALA: strictLocalize({
            id: "Zr6MqB",
            defaultMessage: [
                {
                    type: 0,
                    value: "\u00C5land Islands"
                }
            ]
        }),
        ALB: strictLocalize({
            id: "lR3OIj",
            defaultMessage: [
                {
                    type: 0,
                    value: "Albania"
                }
            ]
        }),
        DZA: strictLocalize({
            id: "cVydRP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Algeria"
                }
            ]
        }),
        ASM: strictLocalize({
            id: "H0s7s8",
            defaultMessage: [
                {
                    type: 0,
                    value: "American Samoa"
                }
            ]
        }),
        AND: strictLocalize({
            id: "8t5+Uu",
            defaultMessage: [
                {
                    type: 0,
                    value: "Andorra"
                }
            ]
        }),
        AGO: strictLocalize({
            id: "XmGInQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Angola"
                }
            ]
        }),
        AIA: strictLocalize({
            id: "3U+IrH",
            defaultMessage: [
                {
                    type: 0,
                    value: "Anguilla"
                }
            ]
        }),
        ATA: strictLocalize({
            id: "ZIpFl3",
            defaultMessage: [
                {
                    type: 0,
                    value: "Antarctica"
                }
            ]
        }),
        ATG: strictLocalize({
            id: "21bo/G",
            defaultMessage: [
                {
                    type: 0,
                    value: "Antigua and Barbuda"
                }
            ]
        }),
        ARG: strictLocalize({
            id: "zHg2hp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Argentina"
                }
            ]
        }),
        ARM: strictLocalize({
            id: "X9iRqs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Armenia"
                }
            ]
        }),
        ABW: strictLocalize({
            id: "YzvI8J",
            defaultMessage: [
                {
                    type: 0,
                    value: "Aruba"
                }
            ]
        }),
        AUS: strictLocalize({
            id: "KIczXx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Australia"
                }
            ]
        }),
        AUT: strictLocalize({
            id: "hsAQ3a",
            defaultMessage: [
                {
                    type: 0,
                    value: "Austria"
                }
            ]
        }),
        AZE: strictLocalize({
            id: "JKAGC4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Azerbaijan"
                }
            ]
        }),
        BHS: strictLocalize({
            id: "nizvFY",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bahamas"
                }
            ]
        }),
        BHR: strictLocalize({
            id: "0g1E1F",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bahrain"
                }
            ]
        }),
        BGD: strictLocalize({
            id: "J9rXcH",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bangladesh"
                }
            ]
        }),
        BRB: strictLocalize({
            id: "IUbr2V",
            defaultMessage: [
                {
                    type: 0,
                    value: "Barbados"
                }
            ]
        }),
        BLR: strictLocalize({
            id: "QPYRey",
            defaultMessage: [
                {
                    type: 0,
                    value: "Belarus"
                }
            ]
        }),
        BEL: strictLocalize({
            id: "1odLN1",
            defaultMessage: [
                {
                    type: 0,
                    value: "Belgium"
                }
            ]
        }),
        BLZ: strictLocalize({
            id: "SML31+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Belize"
                }
            ]
        }),
        BEN: strictLocalize({
            id: "XrwfP2",
            defaultMessage: [
                {
                    type: 0,
                    value: "Benin"
                }
            ]
        }),
        BMU: strictLocalize({
            id: "JGdLnb",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bermuda"
                }
            ]
        }),
        BTN: strictLocalize({
            id: "tqH411",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bhutan"
                }
            ]
        }),
        BOL: strictLocalize({
            id: "TPV2oj",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bolivia"
                }
            ]
        }),
        BES: strictLocalize({
            id: "0Fr4IY",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bonaire, Saint Eustatius and Saba"
                }
            ]
        }),
        BIH: strictLocalize({
            id: "RDRBNU",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bosnia and Herzegovina"
                }
            ]
        }),
        BWA: strictLocalize({
            id: "O7U96J",
            defaultMessage: [
                {
                    type: 0,
                    value: "Botswana"
                }
            ]
        }),
        BVT: strictLocalize({
            id: "3qk112",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bouvet Island"
                }
            ]
        }),
        BRA: strictLocalize({
            id: "I+ZZNe",
            defaultMessage: [
                {
                    type: 0,
                    value: "Brazil"
                }
            ]
        }),
        VGB: strictLocalize({
            id: "1ug57S",
            defaultMessage: [
                {
                    type: 0,
                    value: "British Virgin Islands"
                }
            ]
        }),
        IOT: strictLocalize({
            id: "ph0LQB",
            defaultMessage: [
                {
                    type: 0,
                    value: "British Indian Ocean Territory"
                }
            ]
        }),
        BRN: strictLocalize({
            id: "h70HHK",
            defaultMessage: [
                {
                    type: 0,
                    value: "Brunei Darussalam"
                }
            ]
        }),
        BGR: strictLocalize({
            id: "bKSmoT",
            defaultMessage: [
                {
                    type: 0,
                    value: "Bulgaria"
                }
            ]
        }),
        BFA: strictLocalize({
            id: "XYrRbN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Burkina Faso"
                }
            ]
        }),
        BDI: strictLocalize({
            id: "8T0MvX",
            defaultMessage: [
                {
                    type: 0,
                    value: "Burundi"
                }
            ]
        }),
        KHM: strictLocalize({
            id: "Lht/BN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cambodia"
                }
            ]
        }),
        CMR: strictLocalize({
            id: "vVSyA1",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cameroon"
                }
            ]
        }),
        CAN: strictLocalize({
            id: "NRvxo9",
            defaultMessage: [
                {
                    type: 0,
                    value: "Canada"
                }
            ]
        }),
        CPV: strictLocalize({
            id: "xz/4M8",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cape Verde"
                }
            ]
        }),
        CYM: strictLocalize({
            id: "QACzsU",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cayman Islands"
                }
            ]
        }),
        CAF: strictLocalize({
            id: "aNuPPr",
            defaultMessage: [
                {
                    type: 0,
                    value: "Central African Republic"
                }
            ]
        }),
        TCD: strictLocalize({
            id: "sTLxl/",
            defaultMessage: [
                {
                    type: 0,
                    value: "Chad"
                }
            ]
        }),
        CHL: strictLocalize({
            id: "Cx0lJ4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Chile"
                }
            ]
        }),
        CHN: strictLocalize({
            id: "KqFmIe",
            defaultMessage: [
                {
                    type: 0,
                    value: "China"
                }
            ]
        }),
        HKG: strictLocalize({
            id: "KXDPyP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Hong Kong"
                }
            ]
        }),
        MAC: strictLocalize({
            id: "2vL+hz",
            defaultMessage: [
                {
                    type: 0,
                    value: "Macao"
                }
            ]
        }),
        CXR: strictLocalize({
            id: "8KIDLC",
            defaultMessage: [
                {
                    type: 0,
                    value: "Christmas Island"
                }
            ]
        }),
        CCK: strictLocalize({
            id: "ICGVHw",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cocos (Keeling) Islands"
                }
            ]
        }),
        COL: strictLocalize({
            id: "gsTqGH",
            defaultMessage: [
                {
                    type: 0,
                    value: "Colombia"
                }
            ]
        }),
        COM: strictLocalize({
            id: "ZqmWun",
            defaultMessage: [
                {
                    type: 0,
                    value: "Comoros"
                }
            ]
        }),
        COG: strictLocalize({
            id: "IdoV94",
            defaultMessage: [
                {
                    type: 0,
                    value: "Republic of the Congo"
                }
            ]
        }),
        COD: strictLocalize({
            id: "1aQGMl",
            defaultMessage: [
                {
                    type: 0,
                    value: "Democratic Republic of the Congo"
                }
            ]
        }),
        COK: strictLocalize({
            id: "e+RI12",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cook Islands"
                }
            ]
        }),
        CRI: strictLocalize({
            id: "Cq154j",
            defaultMessage: [
                {
                    type: 0,
                    value: "Costa Rica"
                }
            ]
        }),
        CIV: strictLocalize({
            id: "C2W1ha",
            defaultMessage: [
                {
                    type: 0,
                    value: "C\u00F4te d\u2019Ivoire"
                }
            ]
        }),
        HRV: strictLocalize({
            id: "p6A8cT",
            defaultMessage: [
                {
                    type: 0,
                    value: "Croatia"
                }
            ]
        }),
        CUB: strictLocalize({
            id: "nKpfjO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cuba"
                }
            ]
        }),
        CUW: strictLocalize({
            id: "7RpRZs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cura\u00E7ao"
                }
            ]
        }),
        CYP: strictLocalize({
            id: "DZEnJz",
            defaultMessage: [
                {
                    type: 0,
                    value: "Cyprus"
                }
            ]
        }),
        CZE: strictLocalize({
            id: "+Szthq",
            defaultMessage: [
                {
                    type: 0,
                    value: "Czech Republic"
                }
            ]
        }),
        DNK: strictLocalize({
            id: "CLfdti",
            defaultMessage: [
                {
                    type: 0,
                    value: "Denmark"
                }
            ]
        }),
        DJI: strictLocalize({
            id: "TyjdMl",
            defaultMessage: [
                {
                    type: 0,
                    value: "Djibouti"
                }
            ]
        }),
        DMA: strictLocalize({
            id: "tUS6JW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Dominica"
                }
            ]
        }),
        DOM: strictLocalize({
            id: "ju2vxd",
            defaultMessage: [
                {
                    type: 0,
                    value: "Dominican Republic"
                }
            ]
        }),
        ECU: strictLocalize({
            id: "n3s7dF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ecuador"
                }
            ]
        }),
        EGY: strictLocalize({
            id: "D/Ppv6",
            defaultMessage: [
                {
                    type: 0,
                    value: "Egypt"
                }
            ]
        }),
        SLV: strictLocalize({
            id: "KcVd+u",
            defaultMessage: [
                {
                    type: 0,
                    value: "El Salvador"
                }
            ]
        }),
        GNQ: strictLocalize({
            id: "kOJPz1",
            defaultMessage: [
                {
                    type: 0,
                    value: "Equatorial Guinea"
                }
            ]
        }),
        ERI: strictLocalize({
            id: "offXtT",
            defaultMessage: [
                {
                    type: 0,
                    value: "Eritrea"
                }
            ]
        }),
        EST: strictLocalize({
            id: "68F59w",
            defaultMessage: [
                {
                    type: 0,
                    value: "Estonia"
                }
            ]
        }),
        ETH: strictLocalize({
            id: "6byKTD",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ethiopia"
                }
            ]
        }),
        FLK: strictLocalize({
            id: "mlzyWw",
            defaultMessage: [
                {
                    type: 0,
                    value: "Falkland Islands"
                }
            ]
        }),
        FRO: strictLocalize({
            id: "S3V64D",
            defaultMessage: [
                {
                    type: 0,
                    value: "Faroe Islands"
                }
            ]
        }),
        FJI: strictLocalize({
            id: "A2ZldL",
            defaultMessage: [
                {
                    type: 0,
                    value: "Fiji"
                }
            ]
        }),
        FIN: strictLocalize({
            id: "rxDFa0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Finland"
                }
            ]
        }),
        FRA: strictLocalize({
            id: "Cpr6vw",
            defaultMessage: [
                {
                    type: 0,
                    value: "France"
                }
            ]
        }),
        GUF: strictLocalize({
            id: "kkkLZg",
            defaultMessage: [
                {
                    type: 0,
                    value: "French Guiana"
                }
            ]
        }),
        PYF: strictLocalize({
            id: "7sk4Th",
            defaultMessage: [
                {
                    type: 0,
                    value: "French Polynesia"
                }
            ]
        }),
        ATF: strictLocalize({
            id: "1hDYkY",
            defaultMessage: [
                {
                    type: 0,
                    value: "French Southern Territories"
                }
            ]
        }),
        GAB: strictLocalize({
            id: "Jg0gqZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gabon"
                }
            ]
        }),
        GMB: strictLocalize({
            id: "8LDpiR",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gambia"
                }
            ]
        }),
        GEO: strictLocalize({
            id: "euos5F",
            defaultMessage: [
                {
                    type: 0,
                    value: "Georgia"
                }
            ]
        }),
        DEU: strictLocalize({
            id: "wCeYIy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Germany"
                }
            ]
        }),
        GHA: strictLocalize({
            id: "Gny8TN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ghana"
                }
            ]
        }),
        GIB: strictLocalize({
            id: "FGqLx6",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gibraltar"
                }
            ]
        }),
        GRC: strictLocalize({
            id: "HuNX98",
            defaultMessage: [
                {
                    type: 0,
                    value: "Greece"
                }
            ]
        }),
        GRL: strictLocalize({
            id: "wXIXDe",
            defaultMessage: [
                {
                    type: 0,
                    value: "Greenland"
                }
            ]
        }),
        GRD: strictLocalize({
            id: "Oyfaai",
            defaultMessage: [
                {
                    type: 0,
                    value: "Grenada"
                }
            ]
        }),
        GLP: strictLocalize({
            id: "SwpJE9",
            defaultMessage: [
                {
                    type: 0,
                    value: "Guadeloupe"
                }
            ]
        }),
        GUM: strictLocalize({
            id: "9Zf8mS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Guam"
                }
            ]
        }),
        GTM: strictLocalize({
            id: "nQgYk/",
            defaultMessage: [
                {
                    type: 0,
                    value: "Guatemala"
                }
            ]
        }),
        GGY: strictLocalize({
            id: "HDwstn",
            defaultMessage: [
                {
                    type: 0,
                    value: "Guernsey"
                }
            ]
        }),
        GIN: strictLocalize({
            id: "UiXVBy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Guinea"
                }
            ]
        }),
        GNB: strictLocalize({
            id: "SnJ/sr",
            defaultMessage: [
                {
                    type: 0,
                    value: "Guinea-Bissau"
                }
            ]
        }),
        GUY: strictLocalize({
            id: "aHys0N",
            defaultMessage: [
                {
                    type: 0,
                    value: "Guyana"
                }
            ]
        }),
        HTI: strictLocalize({
            id: "riqahN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Haiti"
                }
            ]
        }),
        HMD: strictLocalize({
            id: "P2IZ+V",
            defaultMessage: [
                {
                    type: 0,
                    value: "Heard and Mcdonald Islands"
                }
            ]
        }),
        VAT: strictLocalize({
            id: "XTlkZO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Vatican City"
                }
            ]
        }),
        HND: strictLocalize({
            id: "htBNcB",
            defaultMessage: [
                {
                    type: 0,
                    value: "Honduras"
                }
            ]
        }),
        HUN: strictLocalize({
            id: "SIz5yt",
            defaultMessage: [
                {
                    type: 0,
                    value: "Hungary"
                }
            ]
        }),
        ISL: strictLocalize({
            id: "UfV/4S",
            defaultMessage: [
                {
                    type: 0,
                    value: "Iceland"
                }
            ]
        }),
        IND: strictLocalize({
            id: "vj3IBj",
            defaultMessage: [
                {
                    type: 0,
                    value: "India"
                }
            ]
        }),
        IDN: strictLocalize({
            id: "NLMHQ2",
            defaultMessage: [
                {
                    type: 0,
                    value: "Indonesia"
                }
            ]
        }),
        IRN: strictLocalize({
            id: "7iN177",
            defaultMessage: [
                {
                    type: 0,
                    value: "Iran, Islamic Republic of"
                }
            ]
        }),
        IRQ: strictLocalize({
            id: "Y3N3uU",
            defaultMessage: [
                {
                    type: 0,
                    value: "Iraq"
                }
            ]
        }),
        IRL: strictLocalize({
            id: "DbRUc4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ireland"
                }
            ]
        }),
        IMN: strictLocalize({
            id: "1XxeCk",
            defaultMessage: [
                {
                    type: 0,
                    value: "Isle of Man"
                }
            ]
        }),
        ISR: strictLocalize({
            id: "Is2UWO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Israel"
                }
            ]
        }),
        ITA: strictLocalize({
            id: "Wyj3zx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Italy"
                }
            ]
        }),
        JAM: strictLocalize({
            id: "a2ZrwW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Jamaica"
                }
            ]
        }),
        JPN: strictLocalize({
            id: "9S6XqK",
            defaultMessage: [
                {
                    type: 0,
                    value: "Japan"
                }
            ]
        }),
        JEY: strictLocalize({
            id: "Vq/TqX",
            defaultMessage: [
                {
                    type: 0,
                    value: "Jersey"
                }
            ]
        }),
        JOR: strictLocalize({
            id: "ijWalZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Jordan"
                }
            ]
        }),
        KAZ: strictLocalize({
            id: "ZZuL4Z",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kazakhstan"
                }
            ]
        }),
        KEN: strictLocalize({
            id: "IEYnV2",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kenya"
                }
            ]
        }),
        KIR: strictLocalize({
            id: "LS+Oey",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kiribati"
                }
            ]
        }),
        PRK: strictLocalize({
            id: "JEatl2",
            defaultMessage: [
                {
                    type: 0,
                    value: "North Korea"
                }
            ]
        }),
        KOR: strictLocalize({
            id: "cMzu/l",
            defaultMessage: [
                {
                    type: 0,
                    value: "South Korea"
                }
            ]
        }),
        XKX: strictLocalize({
            id: "AZ3j5T",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kosovo"
                }
            ]
        }),
        KWT: strictLocalize({
            id: "sXYQvs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kuwait"
                }
            ]
        }),
        KGZ: strictLocalize({
            id: "ME6CVy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Kyrgyzstan"
                }
            ]
        }),
        LAO: strictLocalize({
            id: "3z+UQR",
            defaultMessage: [
                {
                    type: 0,
                    value: "Laos"
                }
            ]
        }),
        LVA: strictLocalize({
            id: "z6g6KS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Latvia"
                }
            ]
        }),
        LBN: strictLocalize({
            id: "Gux60b",
            defaultMessage: [
                {
                    type: 0,
                    value: "Lebanon"
                }
            ]
        }),
        LSO: strictLocalize({
            id: "zi3st7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Lesotho"
                }
            ]
        }),
        LBR: strictLocalize({
            id: "EsDIrc",
            defaultMessage: [
                {
                    type: 0,
                    value: "Liberia"
                }
            ]
        }),
        LBY: strictLocalize({
            id: "jovoCv",
            defaultMessage: [
                {
                    type: 0,
                    value: "Libya"
                }
            ]
        }),
        LIE: strictLocalize({
            id: "v98LJw",
            defaultMessage: [
                {
                    type: 0,
                    value: "Liechtenstein"
                }
            ]
        }),
        LTU: strictLocalize({
            id: "NYm9PS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Lithuania"
                }
            ]
        }),
        LUX: strictLocalize({
            id: "fEt9l3",
            defaultMessage: [
                {
                    type: 0,
                    value: "Luxembourg"
                }
            ]
        }),
        MKD: strictLocalize({
            id: "1rcmh0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Macedonia, Republic"
                }
            ]
        }),
        MDG: strictLocalize({
            id: "eK/l1b",
            defaultMessage: [
                {
                    type: 0,
                    value: "Madagascar"
                }
            ]
        }),
        MWI: strictLocalize({
            id: "yNLtBy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Malawi"
                }
            ]
        }),
        MYS: strictLocalize({
            id: "4kKuzA",
            defaultMessage: [
                {
                    type: 0,
                    value: "Malaysia"
                }
            ]
        }),
        MDV: strictLocalize({
            id: "en/R7w",
            defaultMessage: [
                {
                    type: 0,
                    value: "Maldives"
                }
            ]
        }),
        MLI: strictLocalize({
            id: "WJugug",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mali"
                }
            ]
        }),
        MLT: strictLocalize({
            id: "8grvfp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Malta"
                }
            ]
        }),
        MHL: strictLocalize({
            id: "ONEK14",
            defaultMessage: [
                {
                    type: 0,
                    value: "Marshall Islands"
                }
            ]
        }),
        MTQ: strictLocalize({
            id: "YGBzOr",
            defaultMessage: [
                {
                    type: 0,
                    value: "Martinique"
                }
            ]
        }),
        MRT: strictLocalize({
            id: "h03L43",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mauritania"
                }
            ]
        }),
        MUS: strictLocalize({
            id: "vh5eoN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mauritius"
                }
            ]
        }),
        MYT: strictLocalize({
            id: "BuPTMG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mayotte"
                }
            ]
        }),
        MEX: strictLocalize({
            id: "g8ciUo",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mexico"
                }
            ]
        }),
        FSM: strictLocalize({
            id: "N/5+9s",
            defaultMessage: [
                {
                    type: 0,
                    value: "Micronesia, Federated States"
                }
            ]
        }),
        MDA: strictLocalize({
            id: "7404MX",
            defaultMessage: [
                {
                    type: 0,
                    value: "Moldova"
                }
            ]
        }),
        MCO: strictLocalize({
            id: "rvJX6U",
            defaultMessage: [
                {
                    type: 0,
                    value: "Monaco"
                }
            ]
        }),
        MNG: strictLocalize({
            id: "AnvWtF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mongolia"
                }
            ]
        }),
        MNE: strictLocalize({
            id: "412AkQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Montenegro"
                }
            ]
        }),
        MSR: strictLocalize({
            id: "C98eRy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Montserrat"
                }
            ]
        }),
        MAR: strictLocalize({
            id: "Z55MLZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Morocco"
                }
            ]
        }),
        MOZ: strictLocalize({
            id: "sfz6CP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Mozambique"
                }
            ]
        }),
        MMR: strictLocalize({
            id: "H6DRz0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Myanmar"
                }
            ]
        }),
        NAM: strictLocalize({
            id: "3mBRmW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Namibia"
                }
            ]
        }),
        NRU: strictLocalize({
            id: "e99NUd",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nauru"
                }
            ]
        }),
        NPL: strictLocalize({
            id: "j0n7e4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nepal"
                }
            ]
        }),
        NLD: strictLocalize({
            id: "zPDpum",
            defaultMessage: [
                {
                    type: 0,
                    value: "Netherlands"
                }
            ]
        }),
        ANT: strictLocalize({
            id: "bFmvtf",
            defaultMessage: [
                {
                    type: 0,
                    value: "Netherlands Antilles"
                }
            ]
        }),
        NCL: strictLocalize({
            id: "+25aDR",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Caledonia"
                }
            ]
        }),
        NZL: strictLocalize({
            id: "SKXnHw",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Zealand"
                }
            ]
        }),
        NIC: strictLocalize({
            id: "grGuIG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nicaragua"
                }
            ]
        }),
        NER: strictLocalize({
            id: "ujrhEp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Niger"
                }
            ]
        }),
        NGA: strictLocalize({
            id: "2kg4rp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nigeria"
                }
            ]
        }),
        NIU: strictLocalize({
            id: "2UUJDf",
            defaultMessage: [
                {
                    type: 0,
                    value: "Niue"
                }
            ]
        }),
        NFK: strictLocalize({
            id: "OQ6hDy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Norfolk Island"
                }
            ]
        }),
        MNP: strictLocalize({
            id: "81wBxg",
            defaultMessage: [
                {
                    type: 0,
                    value: "Northern Mariana Islands"
                }
            ]
        }),
        NOR: strictLocalize({
            id: "p1lMN4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Norway"
                }
            ]
        }),
        OMN: strictLocalize({
            id: "0MNdNx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Oman"
                }
            ]
        }),
        PAK: strictLocalize({
            id: "BJ4eDp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Pakistan"
                }
            ]
        }),
        PLW: strictLocalize({
            id: "Wl0bum",
            defaultMessage: [
                {
                    type: 0,
                    value: "Palau"
                }
            ]
        }),
        PSE: strictLocalize({
            id: "RnFxqW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Palestine"
                }
            ]
        }),
        PAN: strictLocalize({
            id: "j8CV0d",
            defaultMessage: [
                {
                    type: 0,
                    value: "Panama"
                }
            ]
        }),
        PNG: strictLocalize({
            id: "9Z7mzY",
            defaultMessage: [
                {
                    type: 0,
                    value: "Papua New Guinea"
                }
            ]
        }),
        PRY: strictLocalize({
            id: "9RWAyB",
            defaultMessage: [
                {
                    type: 0,
                    value: "Paraguay"
                }
            ]
        }),
        PER: strictLocalize({
            id: "duoM3I",
            defaultMessage: [
                {
                    type: 0,
                    value: "Peru"
                }
            ]
        }),
        PHL: strictLocalize({
            id: "PZWwxZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Philippines"
                }
            ]
        }),
        PCN: strictLocalize({
            id: "ED5Fo0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Pitcairn"
                }
            ]
        }),
        POL: strictLocalize({
            id: "5jYEfv",
            defaultMessage: [
                {
                    type: 0,
                    value: "Poland"
                }
            ]
        }),
        PRT: strictLocalize({
            id: "1o+V7l",
            defaultMessage: [
                {
                    type: 0,
                    value: "Portugal"
                }
            ]
        }),
        PRI: strictLocalize({
            id: "WZL5+6",
            defaultMessage: [
                {
                    type: 0,
                    value: "Puerto Rico"
                }
            ]
        }),
        QAT: strictLocalize({
            id: "ruTiVI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Qatar"
                }
            ]
        }),
        REU: strictLocalize({
            id: "/qbSRa",
            defaultMessage: [
                {
                    type: 0,
                    value: "R\u00E9union"
                }
            ]
        }),
        ROU: strictLocalize({
            id: "QEr2Bk",
            defaultMessage: [
                {
                    type: 0,
                    value: "Romania"
                }
            ]
        }),
        RUS: strictLocalize({
            id: "pksKmC",
            defaultMessage: [
                {
                    type: 0,
                    value: "Russia"
                }
            ]
        }),
        RWA: strictLocalize({
            id: "W9+hcP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Rwanda"
                }
            ]
        }),
        BLM: strictLocalize({
            id: "jQG1MZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saint-Barth\u00E9lemy"
                }
            ]
        }),
        SHN: strictLocalize({
            id: "noJU8X",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saint Helena"
                }
            ]
        }),
        KNA: strictLocalize({
            id: "xolDde",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saint Kitts and Nevis"
                }
            ]
        }),
        LCA: strictLocalize({
            id: "7hVOqu",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saint Lucia"
                }
            ]
        }),
        MAF: strictLocalize({
            id: "PchKx9",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saint-Martin"
                }
            ]
        }),
        SPM: strictLocalize({
            id: "PfyfU+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saint Pierre and Miquelon"
                }
            ]
        }),
        VCT: strictLocalize({
            id: "In64Wx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saint Vincent and Grenadines"
                }
            ]
        }),
        WSM: strictLocalize({
            id: "gZ4ytO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Samoa"
                }
            ]
        }),
        SMR: strictLocalize({
            id: "GYw+NW",
            defaultMessage: [
                {
                    type: 0,
                    value: "San Marino"
                }
            ]
        }),
        STP: strictLocalize({
            id: "rlNeq7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sao Tome and Principe"
                }
            ]
        }),
        SAU: strictLocalize({
            id: "gN6qmy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saudi Arabia"
                }
            ]
        }),
        SEN: strictLocalize({
            id: "MDZSbh",
            defaultMessage: [
                {
                    type: 0,
                    value: "Senegal"
                }
            ]
        }),
        SRB: strictLocalize({
            id: "XXc8UO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Serbia"
                }
            ]
        }),
        SYC: strictLocalize({
            id: "DJ3RWa",
            defaultMessage: [
                {
                    type: 0,
                    value: "Seychelles"
                }
            ]
        }),
        SLE: strictLocalize({
            id: "OfulrG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sierra Leone"
                }
            ]
        }),
        SGP: strictLocalize({
            id: "Y/xl0q",
            defaultMessage: [
                {
                    type: 0,
                    value: "Singapore"
                }
            ]
        }),
        SXM: strictLocalize({
            id: "Ae/0u9",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sint Maarten"
                }
            ]
        }),
        SVK: strictLocalize({
            id: "QB+rcu",
            defaultMessage: [
                {
                    type: 0,
                    value: "Slovakia"
                }
            ]
        }),
        SVN: strictLocalize({
            id: "DQxJLG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Slovenia"
                }
            ]
        }),
        SLB: strictLocalize({
            id: "sETeyP",
            defaultMessage: [
                {
                    type: 0,
                    value: "Solomon Islands"
                }
            ]
        }),
        SOM: strictLocalize({
            id: "ylrEZs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Somalia"
                }
            ]
        }),
        ZAF: strictLocalize({
            id: "KWj28m",
            defaultMessage: [
                {
                    type: 0,
                    value: "South Africa"
                }
            ]
        }),
        SGS: strictLocalize({
            id: "FhM/K+",
            defaultMessage: [
                {
                    type: 0,
                    value: "South Georgia and the South Sandwich Islands"
                }
            ]
        }),
        SSD: strictLocalize({
            id: "FaX7kC",
            defaultMessage: [
                {
                    type: 0,
                    value: "South Sudan"
                }
            ]
        }),
        ESP: strictLocalize({
            id: "O23YTi",
            defaultMessage: [
                {
                    type: 0,
                    value: "Spain"
                }
            ]
        }),
        LKA: strictLocalize({
            id: "EYY757",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sri Lanka"
                }
            ]
        }),
        SDN: strictLocalize({
            id: "gJtmCF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sudan"
                }
            ]
        }),
        SUR: strictLocalize({
            id: "89Nh78",
            defaultMessage: [
                {
                    type: 0,
                    value: "Suriname"
                }
            ]
        }),
        SJM: strictLocalize({
            id: "ZtTg2V",
            defaultMessage: [
                {
                    type: 0,
                    value: "Svalbard and Jan Mayen Islands"
                }
            ]
        }),
        SWZ: strictLocalize({
            id: "YvUInB",
            defaultMessage: [
                {
                    type: 0,
                    value: "Eswatini"
                }
            ]
        }),
        SWE: strictLocalize({
            id: "6zhC/J",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sweden"
                }
            ]
        }),
        CHE: strictLocalize({
            id: "/OH3C0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Switzerland"
                }
            ]
        }),
        SYR: strictLocalize({
            id: "1HaZ1w",
            defaultMessage: [
                {
                    type: 0,
                    value: "Syria"
                }
            ]
        }),
        TWN: strictLocalize({
            id: "gIRGTc",
            defaultMessage: [
                {
                    type: 0,
                    value: "Taiwan"
                }
            ]
        }),
        TJK: strictLocalize({
            id: "EviMS7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Tajikistan"
                }
            ]
        }),
        TZA: strictLocalize({
            id: "3R9IpF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Tanzania, United Republic of"
                }
            ]
        }),
        THA: strictLocalize({
            id: "0OH65Y",
            defaultMessage: [
                {
                    type: 0,
                    value: "Thailand"
                }
            ]
        }),
        TLS: strictLocalize({
            id: "uObbtX",
            defaultMessage: [
                {
                    type: 0,
                    value: "Timor-Leste"
                }
            ]
        }),
        TGO: strictLocalize({
            id: "0xnvyf",
            defaultMessage: [
                {
                    type: 0,
                    value: "Togo"
                }
            ]
        }),
        TKL: strictLocalize({
            id: "bEtgjp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Tokelau"
                }
            ]
        }),
        TON: strictLocalize({
            id: "giOCva",
            defaultMessage: [
                {
                    type: 0,
                    value: "Tonga"
                }
            ]
        }),
        TTO: strictLocalize({
            id: "xn8xM4",
            defaultMessage: [
                {
                    type: 0,
                    value: "Trinidad and Tobago"
                }
            ]
        }),
        TUN: strictLocalize({
            id: "sV5eq+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Tunisia"
                }
            ]
        }),
        TUR: strictLocalize({
            id: "3DP3fr",
            defaultMessage: [
                {
                    type: 0,
                    value: "Turkey"
                }
            ]
        }),
        TKM: strictLocalize({
            id: "Eh7dES",
            defaultMessage: [
                {
                    type: 0,
                    value: "Turkmenistan"
                }
            ]
        }),
        TCA: strictLocalize({
            id: "E/zO2j",
            defaultMessage: [
                {
                    type: 0,
                    value: "Turks and Caicos Islands"
                }
            ]
        }),
        TUV: strictLocalize({
            id: "JjZZ6Q",
            defaultMessage: [
                {
                    type: 0,
                    value: "Tuvalu"
                }
            ]
        }),
        UGA: strictLocalize({
            id: "8V2yEJ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Uganda"
                }
            ]
        }),
        UKR: strictLocalize({
            id: "GX53KN",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ukraine"
                }
            ]
        }),
        ARE: strictLocalize({
            id: "M3Wbwb",
            defaultMessage: [
                {
                    type: 0,
                    value: "United Arab Emirates"
                }
            ]
        }),
        GBR: strictLocalize({
            id: "e/cBN/",
            defaultMessage: [
                {
                    type: 0,
                    value: "United Kingdom"
                }
            ]
        }),
        USA: strictLocalize({
            id: "Ork865",
            defaultMessage: [
                {
                    type: 0,
                    value: "United States of America"
                }
            ]
        }),
        UMI: strictLocalize({
            id: "FEHXyd",
            defaultMessage: [
                {
                    type: 0,
                    value: "US Minor Outlying Islands"
                }
            ]
        }),
        URY: strictLocalize({
            id: "UWoJCr",
            defaultMessage: [
                {
                    type: 0,
                    value: "Uruguay"
                }
            ]
        }),
        UZB: strictLocalize({
            id: "8zWpCx",
            defaultMessage: [
                {
                    type: 0,
                    value: "Uzbekistan"
                }
            ]
        }),
        VUT: strictLocalize({
            id: "fxlKUL",
            defaultMessage: [
                {
                    type: 0,
                    value: "Vanuatu"
                }
            ]
        }),
        VEN: strictLocalize({
            id: "eESgKs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Venezuela"
                }
            ]
        }),
        VNM: strictLocalize({
            id: "64OLRM",
            defaultMessage: [
                {
                    type: 0,
                    value: "Vietnam"
                }
            ]
        }),
        VIR: strictLocalize({
            id: "frW1BE",
            defaultMessage: [
                {
                    type: 0,
                    value: "Virgin Islands"
                }
            ]
        }),
        WLF: strictLocalize({
            id: "xADD3l",
            defaultMessage: [
                {
                    type: 0,
                    value: "Wallis and Futuna Islands"
                }
            ]
        }),
        ESH: strictLocalize({
            id: "IavvYm",
            defaultMessage: [
                {
                    type: 0,
                    value: "Western Sahara"
                }
            ]
        }),
        YEM: strictLocalize({
            id: "kfCur7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Yemen"
                }
            ]
        }),
        ZMB: strictLocalize({
            id: "sFUOTS",
            defaultMessage: [
                {
                    type: 0,
                    value: "Zambia"
                }
            ]
        }),
        ZWE: strictLocalize({
            id: "4RTBzG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Zimbabwe"
                }
            ]
        })
    };
    var ISO_TO_COUNTRY_NAME = Object.fromEntries(Object.entries(ISO_TO_COUNTRY_NAME_UNSORTED).sort(function(param, param1) {
        var _param = _sliced_to_array(param, 2), a = _param[1], _param1 = _sliced_to_array(param1, 2), b = _param1[1];
        return a.localeCompare(b, LocalizationStore.get().locale);
    }));
    return omit(ISO_TO_COUNTRY_NAME, [
        "CUB",
        "PRK",
        "SYR",
        "IRN"
    ]);
};
export var getIsoToCountryNamesSorted = function(strictLocalize) {
    return getIsoToCountryNames(strictLocalize);
};
export var ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS = function(strictLocalize) {
    return getIsoToCountryNames(strictLocalize);
};
